import Vue from 'vue'
import Vuex from 'vuex'
import AxiosProvider from './axiosProvider'
import user from './modules/user'
import cc from './modules/cc'
import auth from './modules/auth'
import delivery from './modules/delivery'
import jyb from './modules/jyb'
import ccfile from './modules/ccfile'
import tpHscodeCca from './modules/tpHscodeCca'

Vue.use(Vuex)

const hawbsPrefixPatterns = [
  '710U',
  '710V',
  '710R',
  '7101P',
  '7102P',
  '7103P',
  '7104P',
  '7105P',
  '7106P',
  '7107P',
  '7108P',
  '7109P',
  '7109W',
  'VXZ',
  'VDR',
  'VTY',
  'VNX',
  'YCA1',
  '626',
  '363',
  '581LV',
  '609LV',
  '575QL',
  'PB',
  '650LV',
  '258LV',
  '248LV',
  '451LV',
  '254LV',
  '621LV',
  '0K5Z',
  '0M2',
  '440LV',
  '649LV',
  '472LV',
  '619LV',
  '464LV',
  '\\d{3}LV',
  '\\d{3}SM',
  '\\d{3}AV'
]

const store = new Vuex.Store({
  state: {
    axios: AxiosProvider,
    user: {},
    userInfo: {
      rbacPermissions: [],
    },
    rbac: [],
    sideMenus: [],

    AT0000: '0000-00-00 00:00:00',

    hawbsPrefixPatterns,

    vSnackbar: {
      text: '',
      show: false
    },

    isDialogRawData: false,
    dialogRawData: '',

    isChrome: !!window.chrome,
    // extId: 'lacejchmbljdoaimkbmcflcechgndbim', // 线上
    // extId: 'hlknfainkogakleciiicejdhehgmlmpn', // 本地
    extId: localStorage.extid || '',

    validationRules: {
      required: (value) => (value && value.toString().trim().length > 0) || '必填'
    },

    curTime: Date.now(),
  },
  getters: {
  },
  mutations: {
    init (state, data) {
      state.userInfo = data
      state.user = data.user
      state.rbac = data.rbac
      state.sideMenus = data.sideMenus
    },
    setVSnackbar (state, [text, show = true, timeout = 5000]) {
      state.vSnackbar.text = text
      state.vSnackbar.show = show
      state.vSnackbar.timeout = timeout
    },
    setCurTime (state, v) {
      state.curTime = v
    },
  },
  actions: {
    // 初始化数据，获取已登录用户信息
    init ({ state, commit, dispatch }) {
      return dispatch('user/profile')
    },
  },
  modules: {
    user,
    cc,
    auth,
    delivery,
    jyb,
    ccfile,
    tpHscodeCca,
  }
})

setInterval(() => {
  store.commit('setCurTime', Date.now())
}, 1000)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js